import React from 'react';
import { usePopupFormManager } from 'features/nekst-widgets';
import {
  AfterSubmitFunc,
  Button,
  ButtonColor,
  ButtonSize,
  ButtonVariant,
  FormTemplate,
  IconType, TextInput
} from 'ui-builder';
import {
  CreateDocumentsTemplateRequest,
  DocumentsTemplate,
  useDocumentsTemplatesService
} from 'nekst-api';
import { DocumentLabelsDropdown } from 'features/tasks-forms';

export default function CreateDocumentsTemplateForm(
  props: {
    afterSubmitFunc?: AfterSubmitFunc,
    title?: string,
    initialData?: CreateDocumentsTemplateRequest,
  },
) {
  const documentsTemplateService = useDocumentsTemplatesService();

  const title = props.title || 'Create Documents Template';

  return (
    <FormTemplate<CreateDocumentsTemplateRequest, DocumentsTemplate>
      title={title}
      submitFormFunc={async (data) => {
        return documentsTemplateService.createDocumentsTemplate(data);
      }}
      afterSubmitFunc={props.afterSubmitFunc}
      initialData={props.initialData}
      validationSchema={{
        name: {
          type: 'string',
          constraints: {
            required: true,
          },
        },
        labelsIds: {
          type: 'array',
          constraints: {
            required: true,
          },
        },
      }}
    >
      <TextInput source="name" label="Name" />
      <DocumentLabelsDropdown source="labelsIds" label="Document Labels" />
    </FormTemplate>
  );
}

export function CreateDocumentsTemplateButton() {
  const popupManager = usePopupFormManager();

  return (
    <Button
      text="Create Documents Template"
      variant={ButtonVariant.FILLED}
      size={ButtonSize.MEDIUM}
      color={ButtonColor.BLUE}
      iconType={IconType.PLUS}
      onClick={() => {
        popupManager.openForm(<CreateDocumentsTemplateForm />);
      }}
    />
  );
}
